import Button from '@mui/material/Button';
import { hexWithOpacity, toTitleCase } from 'common/utils';
import { colors } from 'styles/colors';
import useStyles from './styles';
import Circle from 'components/common/Circle/Circle';
import CustomText from 'components/common/CustomText/CustomText';
import { StoreOrderStatus as EStoreOrderStatus } from 'services/storeOrdersService';

interface Props {
  status: EStoreOrderStatus;
}

const STATUS_COLORS: Record<EStoreOrderStatus, string> = {
  on_hold: colors.error,
  pending: colors.pending,
  preparing: colors.preparing,
  ready_to_ship: colors.ready,
  shipped: colors.shipped,
  in_delivery: colors.shipped,
  delivered: colors.delivered,
  delivery_failed: colors.failed,
  cancelled: colors.cancelled,
  partially_returned: colors.returned,
  returned: colors.returned,
};

// A store order's status, drawn the way an order's is.
export default function StoreOrderStatus({ status }: Props) {
  const styles = useStyles();
  const color = STATUS_COLORS[status] ?? colors.text;

  return (
    <div>
      <Button
        className={styles.statusOuterButton}
        sx={{
          paddingLeft: 0,
          backgroundColor: hexWithOpacity(color, 0.1),
          color,
          '&&:hover': {
            bgcolor: hexWithOpacity(color, 0.3),
            color,
          },
        }}
      >
        <Circle boxSize={20} circleSize={6} color={color} />
        <CustomText text={toTitleCase(status)} color={color} fontSize={14} />
      </Button>
    </div>
  );
}
